import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useAddressList = (type) => {
  let command = "user";
  if (type === "branch") command = "BranchAddresses";
  if (type === "all") command = "";
  return useQuery({
    queryKey: ["shipmentaddresslist", type],
    queryFn: async () =>
      callApi({
        path: "shipmentaddresslist",
        command: command,
        data: JSON.stringify({}),
      }),
    staleTime: 5000,
  });
};
